var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',[_c('v-col',[_c('BudgetForm',{ref:"budgetForm",attrs:{"title":_vm.$capitalize(_vm.$tc('model.products_new_replacement_budget_title')),"objective":"substituition","loading":_vm.loading},on:{"submit":_vm.handleCreateBudget}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }